import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

const PreviewImage = ({ src, alt, width, height, style }) => (
  <img src={src} alt={alt} width={width} height={height} style={style} />
);

PreviewImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.shape(),
};

PreviewImage.defaultProps = {
  width: 200,
  height: 200,
  style: undefined,
};

const PreviewFile = ({ url, name, canPreview, isImageButton, imageSize }) => {
  if (canPreview && !isImageButton) {
    return (
      <PreviewImage
        src={url}
        alt={name}
        {...imageSize}
        style={{ objectFit: 'contain' }}
      />
    );
  }

  if (canPreview && isImageButton) {
    return (
      <Button
        variant="outlined"
        color="default"
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <PreviewImage
          src={url}
          alt={name}
          {...imageSize}
          style={{ objectFit: 'contain' }}
        />
      </Button>
    );
  }

  return (
    <Button
      variant="outlined"
      color="default"
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      {name}
    </Button>
  );
};

PreviewFile.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  canPreview: PropTypes.bool,
  isImageButton: PropTypes.bool,
  imageSize: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

PreviewFile.defaultProps = {
  canPreview: true,
  isImageButton: false,
  imageSize: {
    width: 200,
    height: 200,
  },
};

export default PreviewFile;
